import { ModalHost } from '@/components/feedback/ModalHost';
import { ToastHost } from '@/components/feedback/ToastHost';

import { MedicalRoutes } from '@/pages/medical/MedicalRoutes';

export function MedicalApp() {
  return (
    <>
      <MedicalRoutes />
      <ToastHost />
      <ModalHost />
    </>
  );
}
